import React from "react";
import { motion, useReducedMotion } from "framer-motion";
const paths = {
  wave: "M8 92 C 34 30, 66 26, 80 70 S 122 118, 142 58 S 182 14, 194 36",
  loop: "M24 22 C 128 2, 168 44, 104 64 C 38 84, 58 122, 142 102 C 182 92, 192 70, 168 58",
  zigzag: "M10 104 L 40 28 L 72 98 L 102 22 L 134 92 L 166 18"
};
interface ScribbleProps {
  variant: keyof typeof paths;
  className?: string;
  delay?: number;
}
export function Scribble({
  variant,
  className = "",
  delay = 0
}: ScribbleProps) {
  const reduce = useReducedMotion();
  return <svg viewBox="0 0 200 124" className={className} fill="none" aria-hidden="true" data-id="element-623" data-mp="hcwrio0qkxcd">
      <motion.path d={paths[variant]} stroke="#15130b" strokeWidth={9} strokeLinecap="round" strokeLinejoin="round" initial={reduce ? false : {
      pathLength: 0
    }} animate={{
      pathLength: 1
    }} transition={{
      duration: 0.3,
      delay,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-624" data-mp="ck3ktulpjexn" />
    </svg>;
}